class StorerocketStoreLocatorActions extends HTMLElement {
  constructor() {
    super();

    this.resetButton = null;
    this.storeLocatorSelector = this.dataset.storeLocatorSelector || '.storerocket-store-locator';
    this.resetButtonSelector = this.dataset.resetButtonSelector || '.all-results-button';
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.resetButton = this.querySelector(this.resetButtonSelector);

    this.syncButtonStateFromUrl();
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  syncButtonStateFromUrl() {
    const params = new URLSearchParams(window.location.search);

    if (params.has('location')) {
      this.resetButton?.classList.add('is-visible');
    }
  }

  onClick(event) {
    const resetButton = event.target.closest(this.resetButtonSelector);

    if (!resetButton || !this.contains(resetButton)) {
      return;
    }

    const showAllLink = document.querySelector(
      `${this.storeLocatorSelector} .storerocket-show-all-results-link`
    );

    showAllLink?.click();
    resetButton.classList.remove('is-visible');
  }
}

if (!customElements.get('storerocket-store-locator-actions')) {
  customElements.define('storerocket-store-locator-actions', StorerocketStoreLocatorActions);
}
